import { Component } from "@angular/core";
import { NavController, NavParams, PopoverController } from "ionic-angular";
import { Users } from "../../models/users";
import { AuthService } from "../../services/auth.service";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { AppInfo } from './../../app/credentials';
import { TermPage } from "../term/term";

// @IonicPage()
@Component({
  selector: "page-register",
  templateUrl: "register.html"
})
export class RegisterPage {

  version: string;

  userData: Users

  validations_form: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';

  AgreeTerm: boolean = true;

  validation_messages = {
   'email': [
     { type: 'required', message: 'Email is required.' },
     { type: 'pattern', message: 'Enter a valid email.' }
   ],
   'password': [
     { type: 'required', message: 'Password is required.' },
     { type: 'minlength', message: 'Password must be at least 5 characters long.' }
   ]
 };

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,  
    private authService: AuthService,  
    private formBuilder: FormBuilder,
    public popoverCtrl: PopoverController) 
    {
      if (localStorage.getItem("UserDataLocal")) {
        this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));
        console.log("resLocal: " + this.userData.id);  
      }

    this.version = AppInfo.Version;
  }

  ionViewWillLoad(){
    this.validations_form = this.formBuilder.group({
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])),
      password: new FormControl('', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])),
      agreeTerm: new FormControl('', Validators.compose([
      //  Validators.minLength(5),
        Validators.required
      ])),
    });

   
  }

  ionViewDidLoad () {
    this.agreeTermChange();
    console.log(this.AgreeTerm);
  }

  tryRegister(value){
    this.authService.doRegister(value)
     .then(res => {
       console.log(res);
       this.errorMessage = "";
       this.successMessage = "Your account has been created. Please log in.";

     }, err => {
       console.log(err);
       this.errorMessage = err.message;
       this.successMessage = "";
     })
  }

  agreeTermChange(){
    this.AgreeTerm = !this.AgreeTerm;
    this.validations_form.controls["agreeTerm"].setValue(this.AgreeTerm, { onlySelf: false });
    console.log(this.AgreeTerm);
  }

  goLoginPage(){
    this.navCtrl.pop();
  }

  showTerm(event){
    console.log("term");

    const popover = this.popoverCtrl.create(TermPage, {}, { cssClass: "custom-popover"});

    let ev = {
      target : {
        getBoundingClientRect : () => {
          return {
            top: '20px'
          };
        }
      }
    };

    popover.present({
       ev
     // ev: myEvent
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts